/**
 * Última versão cujas Novidades a pessoa abriu, guardada neste navegador. O menu da conta
 * mostra um ponto no avatar e no item Novidades enquanto a versão atual não foi vista.
 */
import { useSyncExternalStore } from 'react'

const STORAGE_KEY = 'synap:whats-new-seen:v1'
const listeners = new Set<() => void>()
/** Vale mesmo quando o navegador não deixa gravar. */
let sessionSeenVersion: string | null = null

export const readWhatsNewSeenVersion = (): string | null => {
  try {
    return window.localStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

export const markWhatsNewSeen = (version: string): void => {
  if (readWhatsNewSeenVersion() === version) return
  try {
    window.localStorage.setItem(STORAGE_KEY, version)
  } catch {
    // Melhor esforço: sem armazenamento o ponto some só nesta sessão.
  }
  sessionSeenVersion = version
  listeners.forEach((listener) => listener())
}

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

const getSnapshot = () => sessionSeenVersion ?? readWhatsNewSeenVersion()

/** true quando as Novidades da versão em uso ainda não foram abertas. */
export const useWhatsNewUnseen = (version: string): boolean => {
  const seen = useSyncExternalStore(subscribe, getSnapshot, () => version)
  return seen !== version
}
